import styled from "styled-components"

export const CatchPhrase = styled.div`
    margin: auto;
    text-align: center;
    font-size: 30px;
    font-weight: 500;
    color: ${p => p.theme.errorPage.catchPhrase}
`